import { handleDownloadMovil, handleDownloadWeb } from "../../functions/handle-download"
import { sendMobile } from "../../functions/mobile"
import { history } from "../../helpers/history"
import { feathersCreateData } from "../../services"
import { urlCertificates } from "../../services/urls"

export const downloadDevice = async (nameFile) => {
    try {
        let send = {
            type: 'action',
            action: 'export_voucher',
            data: urlCertificates + nameFile+".pdf",
            nameFile,
            extension: 'pdf',
            messageSend: 'Certificado'
        }
        sendMobile(JSON.stringify(send))
    } catch (error) {
        //console.log(error)
    }
}

export const handleSendEmailWithVoucher = async (setLoading, CorreoElectronico, handleOpenSnack, nameFile) => {

    setLoading(true)
    let object_send_email_with_voucher = {
        Documento : nameFile,
        Email : CorreoElectronico 
    }

    feathersCreateData('standard-send-email', object_send_email_with_voucher)().then(
        response => {
            //console.log(response)
            const { message, type } = response;

            setLoading(false)
            handleOpenSnack(message, type);
        }
    ).catch(
        error => {
            setLoading(false)
            handleOpenSnack('No se ha enviado correctamente el comprobante. Por favor vuelva a intentar.', 'error')
        }
    )
}

export const handleCancelTransferForm = () => {
    history.push('/')
}


export const handleDownloadVoucher = async (nameFile) => {

    if (localStorage.caja_app !== undefined) {
        // let send = {
        //     type: 'action',
        //     action: 'download_voucher',
        //     data: urlCertificates+nameFile+".pdf",
        //     messageSend: 'Certificado'
        // }
        // sendMobile(JSON.stringify(send))
        handleDownloadMovil(urlCertificates, nameFile)
        
    } else {
        // window.open(urlCertificates+nameFile+".pdf", '_blank');
        handleDownloadWeb(urlCertificates, nameFile)
    }
}